var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { usePopper } from "react-popper";
import maxSizeModifier from "popper-max-size-modifier";
import merge from "lodash/merge";
import styled from "styled-components";
var Arrow = React.forwardRef(function (props, ref) {
    return (React.createElement("div", __assign({ ref: ref }, props)));
});
var Popped = React.forwardRef(function (props, ref) {
    var show = props.show, rest = __rest(props, ["show"]);
    return (React.createElement("div", __assign({ ref: ref }, rest)));
});
var PopperComponent = function (props) {
    var referenceElement = props.referenceElement, config = props.config, _a = props.placement, placement = _a === void 0 ? 'bottom' : _a, onOverlayClick = props.onOverlayClick, boundary = props.boundary, _b = props.sameWidth, sameWidth = _b === void 0 ? false : _b, allowedPlacements = props.allowedPlacements, fallbackPlacements = props.fallbackPlacements, rest = __rest(props, ["referenceElement", "config", "placement", "onOverlayClick", "boundary", "sameWidth", "allowedPlacements", "fallbackPlacements"]);
    var _c = React.useState(null), popperElement = _c[0], setPopperElement = _c[1];
    var _d = React.useState(null), arrowElement = _d[0], setArrowElement = _d[1];
    var memoizedConfig = React.useMemo(function () { return merge({
        overlapReference: false,
        sameWidth: sameWidth,
        offset: {
            x: 0,
            y: 0
        },
    }, config); }, [JSON.stringify(config), sameWidth]);
    var applyMaxSizeModifier = React.useMemo(function () { return ({
        name: "applyMaxSize",
        enabled: true,
        phase: "beforeWrite",
        requires: ["maxSize"],
        fn: function (_a) {
            var state = _a.state;
            var _b = state.modifiersData.maxSize, height = _b.height, width = _b.width;
            state.styles.popper.maxHeight = height + "px";
            state.styles.popper.maxWidth = width + "px";
            state.styles.popper.overflow = "auto";
        }
    }); }, [memoizedConfig]);
    var updateOffset = React.useMemo(function () { return ({
        name: "overlap-reference",
        phase: "afterMain",
        enabled: true,
        fn: function (_a) {
            var state = _a.state;
            var placement = state.placement, rects = state.rects, modifiersData = state.modifiersData;
            if (!modifiersData.popperOffsets) {
                return state;
            }
            var height = (rects.reference || {}).height;
            var _b = modifiersData.popperOffsets, x = _b.x, y = _b.y;
            if (memoizedConfig.overlapReference) {
                modifiersData.popperOffsets.y = placement.includes("bottom") ? y - height : y + height;
            }
            else {
                modifiersData.popperOffsets.x = x + memoizedConfig.offset.x;
                modifiersData.popperOffsets.y = y + memoizedConfig.offset.y;
            }
            return state;
        }
    }); }, [memoizedConfig]);
    var sameWidthModifier = React.useMemo(function () { return ({
        name: "sameWidth",
        enabled: memoizedConfig.sameWidth,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: function (_a) {
            var state = _a.state;
            state.styles.popper.minWidth = state.rects.reference.width + "px";
        },
        effect: function (_a) {
            var state = _a.state;
            state.elements.popper.style.width = state.elements.reference.offsetWidth + "px";
        }
    }); }, [memoizedConfig]);
    var _e = usePopper(referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.current, popperElement, {
        placement: placement,
        // boundary: "document",
        modifiers: [
            { name: "preventOverflow", options: { altBoundary: true, } },
            { name: 'flip', options: { altBoundary: true, allowedAutoPlacements: allowedPlacements, fallbackPlacements: fallbackPlacements } },
            __assign(__assign({}, maxSizeModifier), { options: __assign(__assign({}, maxSizeModifier.options), { padding: { bottom: 10, top: 10 } }) }),
            sameWidthModifier,
            applyMaxSizeModifier,
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            },
            updateOffset
        ]
    }), styles = _e.styles, attributes = _e.attributes, ref = __rest(_e, ["styles", "attributes"]);
    var handleClick = React.useCallback(function (e) {
        var _a;
        if (e.target !== e.currentTarget) {
            return;
        }
        (_a = props.onOverlayClick) === null || _a === void 0 ? void 0 : _a.call(props);
    }, []);
    return (React.createElement(Portal, { onClick: handleClick },
        React.createElement(Popped, __assign({ ref: setPopperElement, style: __assign({}, styles.popper) }, attributes.popper, rest),
            props.children,
            React.createElement(Arrow, __assign({ ref: setArrowElement, style: __assign({}, styles.arrow) }, attributes.arrow)))));
};
export var Popper = React.forwardRef(function (_a, ref) {
    var show = _a.show, props = __rest(_a, ["show"]);
    if (!show)
        return null;
    return React.createElement(PopperComponent, __assign({ ref: ref }, props));
});
export var Portal = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    z-index: 200;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n"], ["\n    z-index: 200;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n"])));
var templateObject_1;
